export { NewsCard } from './NewsCard';
